import React from "react";
import { Link } from "react-router-dom";
import useSeo from "../hooks/useSeo";
import Header from "../components/landing/Header";
import Footer from "../components/landing/Footer";
import WhatsAppFloat from "../components/landing/WhatsAppFloat";
import { POSTS } from "../data/posts";
import { SITE } from "../config/links";
import { ArrowUpRight, Calendar, Clock } from "lucide-react";

export default function BlogIndex() {
    const canonical = `${SITE.domain}/blog`;

    useSeo({
        title: "Blog PUSATCUAN — Tips, Panduan & Link Resmi Terpercaya",
        description:
            "Kumpulan artikel SEO PUSATCUAN: cara akses link resmi terpercaya, tips main pusatcuan slot, panduan deposit, dan strategi di situs hiburan no 1 Indonesia.",
        keywords:
            "blog pusatcuan, tips pusatcuan slot, link resmi terpercaya pusatcuan, panduan pusatcuan, situs hiburan online terpercaya",
        canonical,
        type: "website",
        image: POSTS[0]?.cover,
        jsonLd: {
            "@context": "https://schema.org",
            "@type": "Blog",
            name: "Blog PUSATCUAN",
            url: canonical,
            publisher: {
                "@type": "Organization",
                name: "PUSATCUAN",
                url: SITE.domain,
            },
            blogPost: POSTS.map((p) => ({
                "@type": "BlogPosting",
                headline: p.title,
                description: p.excerpt,
                datePublished: p.date,
                url: `${SITE.domain}/blog/${p.slug}`,
                image: p.cover,
            })),
        },
    });

    return (
        <main data-testid="blog-index-page" className="bg-[#050505] text-white min-h-screen">
            <Header />
            <section className="relative pt-36 pb-16 md:pt-44 md:pb-24 border-b border-white/5">
                <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.12),transparent_70%)]" />
                <div className="relative max-w-6xl mx-auto px-6 md:px-12">
                    <span className="text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
                        Jurnal PUSATCUAN
                    </span>
                    <h1 className="mt-4 text-4xl md:text-6xl font-medium tracking-tighter">
                        Artikel, Tips & <span className="text-gold-gradient">Panduan Resmi</span>
                    </h1>
                    <p className="mt-5 text-white/60 max-w-2xl text-lg">
                        Baca panduan terbaru seputar link resmi terpercaya, pusatcuan
                        slot, dan strategi memaksimalkan pengalaman di platform hiburan
                        digital terbaik.
                    </p>
                </div>
            </section>

            <section className="py-16 md:py-24">
                <div className="max-w-6xl mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-8">
                    {POSTS.map((p, i) => (
                        <Link
                            key={p.slug}
                            to={`/blog/${p.slug}`}
                            data-testid={`blog-card-${i}`}
                            className="group relative overflow-hidden rounded-2xl border border-white/5 bg-[#0c0c0c] hover:border-[#D4AF37]/40 transition-all hover:-translate-y-1"
                        >
                            <div className="aspect-[16/9] overflow-hidden">
                                <img
                                    src={p.cover}
                                    alt={p.title}
                                    loading="lazy"
                                    className="w-full h-full object-cover opacity-70 group-hover:opacity-90 group-hover:scale-105 transition-all duration-700"
                                />
                            </div>
                            <div className="p-7">
                                <div className="flex items-center gap-4 text-xs text-white/50">
                                    <span className="inline-flex items-center gap-1.5 text-[#D4AF37]">
                                        {p.category}
                                    </span>
                                    <span className="inline-flex items-center gap-1.5">
                                        <Calendar size={12} />
                                        {new Date(p.date).toLocaleDateString("id-ID", {
                                            year: "numeric",
                                            month: "long",
                                            day: "numeric",
                                        })}
                                    </span>
                                    <span className="inline-flex items-center gap-1.5">
                                        <Clock size={12} /> {p.read}
                                    </span>
                                </div>
                                <h2 className="mt-4 text-xl md:text-2xl font-medium text-white leading-snug group-hover:text-[#D4AF37] transition-colors">
                                    {p.title}
                                </h2>
                                <p className="mt-3 text-white/60 leading-relaxed line-clamp-3">
                                    {p.excerpt}
                                </p>
                                <span className="mt-5 inline-flex items-center gap-2 text-sm text-[#D4AF37] group-hover:translate-x-1 transition-transform">
                                    Baca Artikel <ArrowUpRight size={14} />
                                </span>
                            </div>
                        </Link>
                    ))}
                </div>
            </section>

            <Footer />
            <WhatsAppFloat />
        </main>
    );
}
